import { type FC, type ReactNode } from 'react';

import { FormattedMessage, FormattedNumber } from 'dibs-react-intl';
import { Tooltip } from 'dibs-elements/exports/Tooltip.tsx';

import dibsCss from 'dibs-css';

const bold = (chunks: ReactNode[]): ReactNode => (
    <span className={dibsCss.sassyFontBodySmallHeavy}>{chunks}</span>
);

const TradeBenefitsNextStatusTooltip: FC<{ onClose: () => void }> = ({ onClose }) => {
    return (
        <Tooltip direction="bottom" isVisible onClose={onClose} closeOnOutsideClick>
            <div className={dibsCss.sassyFontBodySmall}>
                <div>
                    <FormattedMessage
                        id="abt.TradeBenefitsNextStatusTooltip.bronze"
                        defaultMessage="<bold>Bronze:</bold> {min}–{max} Points"
                        values={{
                            bold,
                            min: <FormattedNumber value={0} />,
                            max: <FormattedNumber value={24999} />,
                        }}
                    />
                </div>
                <div>
                    <FormattedMessage
                        id="abt.TradeBenefitsNextStatusTooltip.silver"
                        defaultMessage="<bold>Silver:</bold> {min}–{max} Points"
                        values={{
                            bold,
                            min: <FormattedNumber value={25000} />,
                            max: <FormattedNumber value={99999} />,
                        }}
                    />
                </div>
                <div>
                    <FormattedMessage
                        id="abt.TradeBenefitsNextStatusTooltip.gold"
                        defaultMessage="<bold>Gold:</bold> {min}–{max} Points"
                        values={{
                            bold,
                            min: <FormattedNumber value={100000} />,
                            max: <FormattedNumber value={249999} />,
                        }}
                    />
                </div>
                <div>
                    <FormattedMessage
                        id="abt.TradeBenefitsNextStatusTooltip.platinum"
                        defaultMessage="<bold>Platinum:</bold> {min}+ Points"
                        values={{
                            bold,
                            min: <FormattedNumber value={250000} />,
                        }}
                    />
                </div>
            </div>
        </Tooltip>
    );
};

export default TradeBenefitsNextStatusTooltip;
